<template>

<div 
    class="field" 
    :class="{
        'is-condensed': isCondensed,
        'is-demoted': isDemoted,
        'has-icon': demotedIconFinal,
        'is-sticky': isSticky
    }"
	:sortIndex="(sortingCount > 1 || sort !== 'name' || isSortedReverse) ? isSorted : 0" 
    :data-align="align"
>

    <i class="field-demoted-icon" :class="{['fa-sharp fa-' + demotedIconFinal]: true}" v-if="isDemoted && demotedIconFinal" />

    <slot></slot>

</div>

</template>

<script>

import $field from '@/field'

export default {

    props: ['align', 'isCondensed', 'demotedIcon', 'isDemoted', 'isSticky', 'field', 'filter'],

    computed: {

		sortingCount: function() {
		
			return this.$util.sortcount((this.filter) ? this.$store.getters['filter/' + this.filter] : false)

		},

        demotedIconFinal: function() {

            return (this.demotedIcon) ? $field.type[this.demotedIcon].config.icon : false

        },

		sort: function() {

			return $field.type[this.field.type].sort

		},

		isSorted: function() {

			return this.$util.sorted(this.sort, (this.filter) ? this.$store.getters['filter/' + this.filter] : false) 

		},

		isSortedReverse: function() {

			return this.$util.sorted(this.sort, (this.filter) ? this.$store.getters['filter/' + this.filter] : false, true) 

		}

    }

}

</script>

<style scoped>

.field {
    padding: 5px 0px;
    font-size: 14px;
    min-height: 58px;
    display: flex;
    justify-content: center;
    flex-direction: column;
}

.item.is-condensed .field {
    padding: 2px 0px;
    min-height: 28px;
}

.field.is-demoted {
    height: 24px;
    min-height: 24px;
    padding: 0px;
    font-size: 12px;
    flex-direction: row;
    background-color: #f7f7f7;
    border-radius: 4px;
}

.field.is-demoted.has-icon {
    justify-content: space-between;
    padding: 0px 5px;
}

.is-mobile .field.is-condensed {
    min-height: 28px;
}

.field.is-sticky {
    opacity: 0;
    pointer-events: none;
}

.field[data-align="center"] {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
}

.field-demoted-icon {
    font-size: 10px;
    color: #617080;
}

</style>